module.exports = __webpack_public_path__ + "img/secret.ebde2c37.png";